import * as React from 'react';

import { cn } from '@/lib/utils';

interface ViewHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  title?: string;
  titleComponent?: React.ReactNode;
  titleClassName?: string;
  actionsClassName?: string;
  children?: React.ReactNode;
}

export function ViewHeader({
  title,
  titleComponent,
  titleClassName,
  actionsClassName,
  className,
  children,
  ...props
}: ViewHeaderProps) {
  return (
    <div
      className={cn('flex items-center justify-between min-h-10', className)}
      {...props}
    >
      <div className={cn('flex items-center gap-2', titleClassName)}>
        {/* Sidebar trigger for mobile view */}
        {/* <SidebarTrigger /> */}
        {titleComponent ?? (
          <h1 className="text-2xl font-bold tracking-tight">{title}</h1>
        )}
      </div>
      {children && (
        <div className={cn('flex items-center gap-2', actionsClassName)}>
          {children}
        </div>
      )}
    </div>
  );
}

export function ViewContent({
  children,
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'rounded-t-md rounded-b-none border flex-1 bg-white min-h-0 overflow-hidden flex flex-col',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
